import { render, staticRenderFns } from "./CetakRiwayatKontrol.vue?vue&type=template&id=8fb473ae&"
import script from "./CetakRiwayatKontrol.vue?vue&type=script&lang=js&"
export * from "./CetakRiwayatKontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports